import React from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner';
import * as Icons from 'lucide-react';
import { careerPerks } from '../mock';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const Careers = () => {
  return (
    <>
      <PageBanner title="Careers" subtitle="Do work that matters, with a team that genuinely looks after its people." crumb="Careers" variant="light" image="/generated/svc-staffing.png" />

      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-slate-900 mb-3">Why work with us</h2>
            <p className="font-body text-slate-600">Join a supportive, close-knit team of care professionals who make a real difference every day.</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {careerPerks.map((p, i) => {
              const Icon = Icons[p.icon] || Icons.Star;
              return (
                <div key={i} className="bg-brand-blue-light rounded-2xl p-8 text-center hover:-translate-y-1.5 transition-transform duration-300">
                  <div className="w-16 h-16 rounded-2xl bg-white flex items-center justify-center mx-auto mb-5"><Icon className="w-8 h-8 text-brand-blue" strokeWidth={1.8} /></div>
                  <h3 className="font-heading font-semibold text-lg text-slate-900 mb-3">{p.title}</h3>
                  <p className="font-body text-sm text-slate-600 leading-relaxed">{p.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="pb-20 lg:pb-28 bg-white">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="rounded-3xl bg-brand-blue text-white p-10 md:p-14 text-center">
            <h2 className="font-heading font-bold text-2xl md:text-3xl mb-4">Ready to join our team?</h2>
            <p className="font-body text-white/85 max-w-xl mx-auto mb-8">We're always keen to hear from caring, capable people. Get in touch to start a conversation about joining Trusted Companion.</p>
            <Button asChild className="bg-brand-mint hover:bg-teal-300 text-brand-blue-dark font-semibold h-12 px-8 rounded-full">
              <Link to="/contact" className="inline-flex items-center gap-2">Get in touch <ArrowRight className="w-4 h-4" /></Link>
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Careers;
